module.exports = __webpack_public_path__ + "img/rate-my-flowers.00ea9d6b.svg";